import { 
    SHOW_START_SCREEN,
    SWITCH_MENU,
    PLUS_MENU_LEVEL, 
    MINUS_MENU_LEVEL, 
    MINUS_INDEX_FIRST_LEVEL, 
    PLUS_INDEX_FIRST_LEVEL,
    PLUS_INDEX_SECOND_LEVEL,
    MINUS_INDEX_SECOND_LEVEL,
    PLUS_INDEX_THIRD_LEVEL,
    MINUS_INDEX_THIRD_LEVEL,
    PLUS_INDEX_FOURTH_LEVEL,
    MINUS_INDEX_FOURTH_LEVEL,
    PLUS_INDEX_FOURTH_LEVEL_NEXT,
    MINUS_INDEX_FOURTH_LEVEL_PREV,
    PLUS_INDEX_FIFTH_LEVEL,
    MINUS_INDEX_FIFTH_LEVEL,
    PLUS_INDEX_FIFTH_LEVEL_NEXT,
    MINUS_INDEX_FIFTH_LEVEL_PREV,
    PLUS_INDEX_SIXTH_LEVEL_NEXT,
    MINUS_INDEX_SIXTH_LEVEL_PREV,
} from './actionCreators';

import data from './data';

const initialState = {
    showMenu: false,
    menuLevel: 1,
    firstLevelIndex: 0,
    secondLevelIndex: 0,
    thirdLevelIndex: null,
    fourthLevelIndex: null,
    fifthLevelIndex: null,
    sixLevelIndex: null,
    topbar: '',
    data: data,
    showSubList: false,
}

export default function rootReducer(state = initialState, action) {

    const firstLevelMenu = Object.keys(state.data);
    const secondLevelMenu = () => {
        const secondLevelMenu = state.data[firstLevelMenu[state.firstLevelIndex]].settings;
        return secondLevelMenu ? Object.keys(secondLevelMenu) : undefined;
    }
    const thirdLevelMenu = () => {
        const secondLevelMenu = state.data[firstLevelMenu[state.firstLevelIndex]].settings;
        return secondLevelMenu ? Object.keys(state.data[firstLevelMenu[state.firstLevelIndex]].settings[Object.keys(secondLevelMenu)[state.secondLevelIndex]].settings) : undefined;
    }
    const fourthLevelMenu = () => {
        const fourthLevelMenu = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings;
        return fourthLevelMenu ? Object.keys(fourthLevelMenu) : undefined;
    }
    const fifthLevelMenu = () => {
        const fifthLevelMenu = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings[fourthLevelMenu()[state.fourthLevelIndex]].settings;
        return fifthLevelMenu ? Object.keys(fifthLevelMenu) : undefined;
    }
    let fourthLevelObject;
    let fifthLevelObject;
    let sixthLevelObject;

    let newState = {...state};

    switch(action.type) {
        case SWITCH_MENU: 
            newState.showMenu = !state.showMenu;
            return {
                ...newState
            };
        case SHOW_START_SCREEN:
            newState.showMenu = false;
            return {
                ...newState
            };
        case PLUS_MENU_LEVEL: 
            if(state.menuLevel === 1) {
                if(state.firstLevelIndex !== firstLevelMenu.length - 1) {
                    newState.menuLevel = 3;
                    newState.thirdLevelIndex = 0;
                };
            } else if (state.menuLevel === 3) {
                if (state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].disabled) {
                    // do nothing
                } else {
                    const fourthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]];
                    const fourthLevelMenu =  fourthLevelObject.settings;
                    const defaultItem = fourthLevelObject.default;
                    const topbar = fourthLevelObject.type === 'big_select' || fourthLevelObject.type === 'off' ? 'hidden' : '';
         
                    const fourthLevelIndex = Array.isArray(fourthLevelMenu) && fourthLevelMenu.indexOf(defaultItem) !== -1 ? fourthLevelMenu.indexOf(defaultItem) : 0;

                    if(fourthLevelObject.type !== undefined) {
                        newState.menuLevel = 4;
                        newState.fourthLevelIndex = fourthLevelIndex;
                        newState.topbar = topbar;
                    } else {
                        if(state.showSubList === true) {
                        let subSettingsItems;
                        let subSetItemsArray;

                        subSettingsItems = fourthLevelObject.settings;
                        subSetItemsArray = Object.keys(subSettingsItems);
                        const thirdLevelItemName = thirdLevelMenu()[state.thirdLevelIndex].toLowerCase().replace(/[" "]/g, "-");
                        const newDataObj = state.data;

                        if (thirdLevelItemName === "main-rec-format") {
                            let willDisable;
                            switch (subSettingsItems[subSetItemsArray[state.fourthLevelIndex]]) {
                            case "RAW (CFast)":
                                willDisable = true;
                                break;
                            default: 
                                willDisable = false;
                                break;
                            }

                            newDataObj[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings["Recording Mode"].disabled = willDisable;
                            newDataObj[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings["Recording Mode"].settings = willDisable ?
                            ['---'] :
                            ['Normal Recording', 'Slow Motion Recording', 'Pre-Recording', 'Frame Recording', 'Interval Recording', 'Continuous Recording']; 
                            newDataObj[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings["Recording Mode"].default = willDisable ?
                            '---' :
                            'Normal Recording';
                            newDataObj[firstLevelMenu[state.firstLevelIndex]].settings['2'].settings['Resolution/Color Sampling'].disabled = willDisable;
                            newDataObj[firstLevelMenu[state.firstLevelIndex]].settings['2'].settings['Resolution/Color Sampling'].settings = willDisable ?
                            ['4096x2160 10bit'] : 
                            ['3840x2160 YCC420 8 bit', '1920x1080 YCC420 8 bit'];
                            newDataObj[firstLevelMenu[state.firstLevelIndex]].settings['2'].settings['Resolution/Color Sampling'].default = willDisable ?
                            '4096x2160 10bit' : 
                            '3840x2160 YCC420 8 bit';
                        }

                        newDataObj[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].default = subSettingsItems[subSetItemsArray[state.fourthLevelIndex]];

                        newState.data = newDataObj;
                        newState.showSubList = false;
                        newState.fourthLevelIndex = null;

                        } else {
                            const fourthLevelIndexForSublist = state.fourthLevelIndex === null ? fourthLevelIndex : null;
                    
                            newState.showSubList = !state.showSubList;
                            newState.fourthLevelIndex = fourthLevelIndexForSublist;
                        }
                    }
                }
            }  else if (state.menuLevel === 4) {
                
                let subSettingsItems;
                let subSetItemsArray;
                
                fourthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]];

                if (state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings !== undefined) {
                    subSettingsItems = fourthLevelObject.settings;
                    subSetItemsArray = Object.keys(subSettingsItems);
                }

                if (fourthLevelObject.type === undefined) {
                    // do smth
                } else if (fourthLevelObject.type === 'list') {
                    if (state.fourthLevelIndex === -1) {
                        newState.menuLevel = 3;
                        newState.fourthLevelIndex = null; 
                    } else if (subSettingsItems[subSetItemsArray[state.fourthLevelIndex]].settings || subSettingsItems[subSetItemsArray[state.fourthLevelIndex]].type === 'keyboard' || subSettingsItems[subSetItemsArray[state.fourthLevelIndex]].type === 'question') {

                        if (fourthLevelObject.settings[subSetItemsArray[state.fourthLevelIndex]].disabled) {
                            //return; do nothing
                        }

                        if (fourthLevelObject.settings[subSetItemsArray[state.fourthLevelIndex]].type === undefined) {
                            const fifthLevelIndexForSublist = state.fifthLevelIndex === null ? 0 : null;
                            newState.showSubList = !state.showSubList;
                            newState.fifthLevelIndex = fifthLevelIndexForSublist;
                        } else {
                            const fifthLevelObject = subSettingsItems[subSetItemsArray[state.fourthLevelIndex]];
                            const topbar = fifthLevelObject.type === 'keyboard' || fifthLevelObject.type === 'select_cancel' || fifthLevelObject.type === 'register' ? 'hidden' : '';
                            const defaultItem = subSettingsItems[subSetItemsArray[state.fourthLevelIndex]].default;
                            
                            const fifthLevelIndex = Array.isArray(subSettingsItems[subSetItemsArray[state.fourthLevelIndex]].settings) && subSettingsItems[subSetItemsArray[state.fourthLevelIndex]].settings.indexOf(defaultItem) !== -1 
                            ? subSettingsItems[subSetItemsArray[state.fourthLevelIndex]].settings.indexOf(defaultItem) 
                            : 0;
            
                            newState.menuLevel = 5;
                            newState.fifthLevelIndex = fifthLevelIndex;
                            newState.topbar = topbar;
                        }
                    } 
                } else if (fourthLevelObject.type === 'selection_tree') {
                    if (state.fifthLevelIndex !== null) {
                        newState.fifthLevelIndex = null;
                    } else {
                        newState.fifthLevelIndex = 0;
                    }
                } else {
                    newState.menuLevel = 3;
                    newState.fourthLevelIndex = null;
                    newState.fifthLevelIndex = null;
                    newState.topbar = '';
                }
            } else if (state.menuLevel === 5) {
                fifthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings[fourthLevelMenu()[state.fourthLevelIndex]];

                if (fifthLevelObject.type === 'list') {
                    const fifthLevelItemsArray = Object.keys(fifthLevelObject.settings);
                    const sixthLevelObject = fifthLevelObject.settings[fifthLevelItemsArray[state.fifthLevelIndex]];
            
                    if (state.fifthLevelIndex === -1) {
                        newState.menuLevel = 4;
                        newState.fifthLevelIndex = null;
                    } else {
                        if (sixthLevelObject.disabled) {
                            // do nothing
                        } else {
                            newState.menuLevel = 6; 
                            newState.sixLevelIndex = 0;
                        }
                    }
                } else if (fifthLevelObject.type === 'input') {
                    if (state.fifthLevelIndex === 0) {
                        newState.menuLevel = 6;
                        newState.topbar = 'hidden';
                        newState.sixLevelIndex = 0;
                    } else {
                        newState.menuLevel = 4;
                    }
                } else {
                    newState.menuLevel = 4;
                    newState.topbar = '';
                    newState.fifthLevelIndex = null;
                }
            } else if (state.menuLevel === 6) {
                newState.menuLevel = 5;
                newState.sixLevelIndex = null;
                newState.topbar = '';
            }
        
            return {
                ...newState
            };
        case MINUS_MENU_LEVEL:
            if(state.menuLevel === 1) {
                if(state.firstLevelIndex !== firstLevelMenu.length - 1) {
                    newState.menuLevel = 3;
                    newState.thirdLevelIndex = thirdLevelMenu().length - 1
                }
            } else if(state.menuLevel === 3) {
                if(state.showSubList === true) {
                    newState.showSubList = false;
                    newState.fourthLevelIndex = null;
                } else {
                    newState.menuLevel = 1;
                    newState.thirdLevelIndex = null;
                }
            } else if(state.menuLevel === 4) {
                if(state.showSubList === true) {
                    newState.showSubList = false;
                    newState.fifthLevelIndex = null;
                } else {
                    fourthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]];
                    if (fourthLevelObject.type === 'selection_tree') {
                        if (state.fifthLevelIndex !== null) {
                            newState.fifthLevelIndex = null;
                        } else {
                            newState.menuLevel = 3;
                            newState.fourthLevelIndex = null;
                        }
                    } else {
                        newState.menuLevel = 3;
                        newState.topbar = '';
                    }
                }
            } else if(state.menuLevel === 5) {
                newState.menuLevel = 4; 
                newState.topbar = '';
                newState.fifthLevelIndex = null;
            } else if(state.menuLevel === 6) {
                newState.menuLevel = 5;
                newState.topbar = '';
            }
            
            return {
                ...newState
            }; 
        case PLUS_INDEX_FIRST_LEVEL: 
            if (state.firstLevelIndex >= firstLevelMenu.length - 1) {
                newState.firstLevelIndex = 0;
            } else {
                newState.firstLevelIndex ++;
            }

            newState.secondLevelIndex = 0;
            newState.thirdLevelIndex = null;
            return {
                ...newState
            };
        case MINUS_INDEX_FIRST_LEVEL:
            if (state.firstLevelIndex <= 0) {
                newState.firstLevelIndex = firstLevelMenu.length - 1;
                newState.secondLevelIndex = 0;
                newState.thirdLevelIndex = null;
            } else {
                newState.firstLevelIndex-- ;
                newState.secondLevelIndex = 0;
                newState.thirdLevelIndex = null;
            }
            return {
                ...newState
            };
        case PLUS_INDEX_SECOND_LEVEL: 
            if (state.secondLevelIndex < secondLevelMenu().length - 1) {
                newState.secondLevelIndex++;
                newState.thirdLevelIndex = 0;
            } else if (state.firstLevelIndex === firstLevelMenu.length - 2) {
                newState.firstLevelIndex = 0;
                newState.secondLevelIndex = 0;
                newState.thirdLevelIndex = 0;
            } else {
                newState.firstLevelIndex++;
                newState.secondLevelIndex = 0;
                newState.thirdLevelIndex = 0;
            }
            return {
                ...newState
            };
        case MINUS_INDEX_SECOND_LEVEL:
            if (state.secondLevelIndex > 0) {
                newState.secondLevelIndex--;
                newState.thirdLevelIndex = 0;
            } else if (state.firstLevelIndex === 0) {
                newState.firstLevelIndex = firstLevelMenu.length - 2;
                newState.secondLevelIndex = Object.keys(state.data[firstLevelMenu[firstLevelMenu.length - 2]].settings).length - 1;
                newState.thirdLevelIndex = 0;
            } else {
                newState.firstLevelIndex--;
                newState.secondLevelIndex = Object.keys(state.data[firstLevelMenu[state.firstLevelIndex - 1]].settings).length - 1;
                newState.thirdLevelIndex = 0;
            }
            return {
                ...newState
            }
        case PLUS_INDEX_THIRD_LEVEL:
            if (state.thirdLevelIndex < thirdLevelMenu().length - 1) {
                newState.thirdLevelIndex++;
            } else {
                newState.menuLevel = 1;
                newState.thirdLevelIndex = null;
            }
            return {
                ...newState
            }
        case MINUS_INDEX_THIRD_LEVEL:
            if (state.thirdLevelIndex > 0) {
                newState.thirdLevelIndex--;
            } else {
                newState.menuLevel = 1;
                newState.thirdLevelIndex = null;
            }
            
            return {
                ...newState
            };
        case MINUS_INDEX_FOURTH_LEVEL:
            if(state.showSubList === true) {
                if (state.fourthLevelIndex > 0) {
                    newState.fourthLevelIndex--;
                }
            } else {
                fourthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]];

                if (fourthLevelObject.type === 'list') {
                    if (state.fourthLevelIndex <= -1) {
                        newState.fourthLevelIndex = fourthLevelMenu().length - 1;
                    } else {
                        newState.fourthLevelIndex--;
                    }
                } else if (fourthLevelObject.type === 'vertical_select') {
                    if (state.fourthLevelIndex <= 0) {
                        newState.fourthLevelIndex = fourthLevelMenu().length - 1;
                    } else {
                        newState.fourthLevelIndex--;
                    }
                } else if (fourthLevelObject.type === 'big_select') {
                    if (state.fourthLevelIndex > 0) {
                        newState.fourthLevelIndex--;
                    }
                } else if (fourthLevelObject.type === 'selection_tree') {
                    if (state.fifthLevelIndex === null) {
                        if (state.fourthLevelIndex > 0) {
                            newState.fourthLevelIndex--;
                        } else {
                            newState.fourthLevelIndex = Object.keys(fourthLevelObject.settings.options).length - 2; // ?
                        }
                    }
                } else {
                    // return; do nothing
                }
            }
            return {
                ...newState
            };
        case MINUS_INDEX_FOURTH_LEVEL_PREV:
            fourthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]];

            if (fourthLevelObject.type === 'selection_tree') {
                if (state.fifthLevelIndex !== null) {
                    if (state.fifthLevelIndex <= 0) {
                        newState.fifthLevelIndex = fourthLevelObject.settings.options[state.fourthLevelIndex].length - 1;
                    } else {
                        newState.fifthLevelIndex--;
                    }
                }
            } else if (fourthLevelObject.type === 'question') {
                if(state.fourthLevelIndex === 1) {
                    newState.fourthLevelIndex = 0;
                }
            } else if (fourthLevelObject.type === 'change_reset') {
                if(state.fourthLevelIndex > 0) {
                    newState.fourthLevelIndex--;
                }
            } else {
                // return; do nothing
            }
            return {
                ...newState
            };
        case PLUS_INDEX_FOURTH_LEVEL:
            if(state.showSubList === true) {
                if (state.fourthLevelIndex < fourthLevelMenu().length - 1) {
                    newState.fourthLevelIndex++;
                }
            } else {
                fourthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]];

                if (fourthLevelObject.type === 'list') {
                    if (state.fourthLevelIndex < fourthLevelMenu().length - 1) {
                        newState.fourthLevelIndex++;
                    } else if (state.fourthLevelIndex >= fourthLevelMenu().length - 1) {
                        newState.fourthLevelIndex = -1;
                    }
                } else if (fourthLevelObject.type === 'vertical_select') {
                    if (state.fourthLevelIndex < fourthLevelMenu().length - 1) {
                        newState.fourthLevelIndex++;
                    } else if (state.fourthLevelIndex >= fourthLevelMenu.length - 1) {
                        newState.fourthLevelIndex = 0;
                    }
                } else if (fourthLevelObject.type === 'big_select') {
                    if (state.fourthLevelIndex < fourthLevelMenu().length - 1) {
                        newState.fourthLevelIndex++;
                    }
                } else if (fourthLevelObject.type === 'selection_tree') {
                    if (state.fifthLevelIndex === null) {
                        if (state.fourthLevelIndex < Object.keys(fourthLevelObject.settings.options).length - 2) { // ?
                            newState.fourthLevelIndex++;
                        } else {
                            newState.fourthLevelIndex = 0;
                        }
                    }
                } else {
                    //return; do nothing
                }
            }
            return {
                ...newState
            };
        case PLUS_INDEX_FOURTH_LEVEL_NEXT:
            fourthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]];

            if (fourthLevelObject.type === 'selection_tree') {
                if (state.fifthLevelIndex !== null) {
                    if (state.fifthLevelIndex < fourthLevelObject.settings.options[state.fourthLevelIndex].length - 1) {
                        newState.fifthLevelIndex++;
                    } else {
                        newState.fifthLevelIndex = 0;
                    }
                }
            } else if (fourthLevelObject.type === 'question') {
                if(state.fourthLevelIndex === 0) {
                  newState.fourthLevelIndex = 1;
                }
            } else if (fourthLevelObject.type === 'change_reset') {
                if(state.fourthLevelIndex < 2) {
                  newState.fourthLevelIndex++;
                }
            }
            return {
                ...newState
            };
        case PLUS_INDEX_FIFTH_LEVEL:
            if(state.showSubList === true) {
                if (state.fifthLevelIndex < fifthLevelMenu().length - 1) {
                    newState.fifthLevelIndex++;
                };
            } else {     
                fifthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings[fourthLevelMenu()[state.fourthLevelIndex]];

                if (fifthLevelObject.type === 'list') {
                    if (state.fifthLevelIndex < fifthLevelMenu().length - 1) {
                        newState.fifthLevelIndex++;
                    } else {
                        newState.fifthLevelIndex = -1;
                    }
                } else if (fifthLevelObject.type === 'vertical_select') {
                    if (state.fifthLevelIndex < fifthLevelMenu().length - 1) {
                        newState.fifthLevelIndex++;
                    } else {
                        newState.fifthLevelIndex = 0;
                    }
                } else if (fifthLevelObject.type === 'input') {
                    newState.fifthLevelIndex = 1;
                }
            }
            return {
                ...newState
            };
        case MINUS_INDEX_FIFTH_LEVEL:
            if(state.showSubList === true) {
                if (state.fifthLevelIndex > 0) {
                    newState.fifthLevelIndex--;
                };
            } else {
                fifthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings[fourthLevelMenu()[state.fourthLevelIndex]];
            
                if (fifthLevelObject.type === 'list') {
                    if (state.fifthLevelIndex <= -1) {
                        newState.fifthLevelIndex = fifthLevelMenu().length - 1;
                    } else {
                        newState.fifthLevelIndex--;
                    }
                } else if (fifthLevelObject.type === 'vertical_select') {
                    if (state.fifthLevelIndex <= 0) {       
                        newState.fifthLevelIndex = fifthLevelMenu().length - 1;
                    } else {
                        newState.fifthLevelIndex--;
                    }
                } else if (fifthLevelObject.type === 'input') {
                    newState.fifthLevelIndex = 0;
                } else {
                    //do nothing
                }
            }
            return {
                ...newState
            };
        case PLUS_INDEX_FIFTH_LEVEL_NEXT:
            fifthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings[fourthLevelMenu()[state.fourthLevelIndex]];

            if (fifthLevelObject.type === 'select' || fifthLevelObject.type === 'select_cancel') {
                //const fifthLevelMenu = this.fifthLevelMenu();
                if (state.fifthLevelIndex < fifthLevelMenu().length - 1 && state.fifthLevelIndex !== -1) {
                    newState.fifthLevelIndex++;
                } else {
                    newState.fifthLevelIndex = -1;
                }
            } else if (fifthLevelObject.type === 'question') {
                if(state.fifthLevelIndex === 0) {
                    newState.fifthLevelIndex = 1;
                }
            } else if (fifthLevelObject.type === 'change_reset') {
                if(state.fifthLevelIndex < 2) {
                    newState.fifthLevelIndex++;
                }
            }
            return {
                ...newState
            };
        case MINUS_INDEX_FIFTH_LEVEL_PREV:
            fifthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings[fourthLevelMenu()[state.fourthLevelIndex]];

            if (fifthLevelObject.type === 'select' || fifthLevelObject.type === 'select_cancel') {
                if (state.fifthLevelIndex > 0) {
                    newState.fifthLevelIndex--;
                } else if (state.fifthLevelIndex === -1) {
                    newState.fifthLevelIndex = fifthLevelMenu().length - 1;
                }
            } else if (fifthLevelObject.type === 'question') {
                if(state.fifthLevelIndex === 1) {
                    newState.fifthLevelIndex = 0;
                }
            } else if (fifthLevelObject.type === 'change_reset') {
                if(state.fifthLevelIndex > 0) {
                    newState.fifthLevelIndex--;
                }
            }
            return {
                ...newState
            };
        case PLUS_INDEX_SIXTH_LEVEL_NEXT:
            sixthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings[fourthLevelMenu()[state.fourthLevelIndex]].settings[fifthLevelMenu()[state.fifthLevelIndex]];

            if (sixthLevelObject.type === 'question') {
                if(state.sixLevelIndex === 0) {
                    newState.sixLevelIndex = 1;
                }
            }
            return {
                ...newState
            };
        case MINUS_INDEX_SIXTH_LEVEL_PREV:
            sixthLevelObject = state.data[firstLevelMenu[state.firstLevelIndex]].settings[secondLevelMenu()[state.secondLevelIndex]].settings[thirdLevelMenu()[state.thirdLevelIndex]].settings[fourthLevelMenu()[state.fourthLevelIndex]].settings[fifthLevelMenu()[state.fifthLevelIndex]];

            if (sixthLevelObject.type === 'question') {
                if(state.sixLevelIndex === 1) {
                    newState.sixLevelIndex = 0;
                }
            }
            return {
                ...newState
            };
        default: return state;
        
    }
}